export const Bio = {
  name: "DANGI KUNAL",
  roles: ["Full Stack Developer", "Web Developer", "MERN Stack Developer", "Backend Developer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/kunal0157",
  resume:
    "https://drive.google.com/file/d/1FP5oar0mRHCnCU-3d9xM5xlMSQmpjBkY/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
  twitter: "https://twitter.com/dangi_kuna50900",
  insta: "https://www.instagram.com/kunal_dangi12/",
  facebook: "https://www.facebook.com/profile.php?id=100015899238196",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Tailwind css",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "C++",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      /*
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },*/
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "Postman",
        image:
          "https://i.pinimg.com/564x/af/70/80/af70800826083538b7cfab54a98c55f1.jpg",
      },
      {
        name: "Figma",
        image:
          "https://i.pinimg.com/564x/63/a7/b1/63a7b1894b3210d07e434e9d12170586.jpg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://ui-avatars.com/api/?name=iTech+Sarathi&background=303030&color=fff&size=200",
    role: "Full-Stack Developer",
    company: "iTech Sarathi Private Limited",
    date: "Sep 2024 – Present",
    desc: "Spearheaded the development of a comprehensive custom ERP software handling complex modules like Stock Management, HRM, CRM, Sales, and Plant Operations.\n\n• Engineered complete Production Flow architectures including Production Orders, Work Orders, and WR Screens.\n• Built scalable and responsive frontend interfaces using React.js, Next.js, and Tailwind CSS.\n• Developed robust RESTful backend APIs and optimized routing transactions using Node.js and Express.js.\n• Architected a coaching platform featuring payment integration, hall ticket generation, and teacher/student result portals.\n• Directly collaborated with clients to troubleshoot bugs, implement iterative updates, and dramatically improve application performance.",
    skills: [
      "React.js",
      "Next.js",
      "Node.js",
      "Express.js",
      "Tailwind CSS",
      "REST APIs"
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://ui-avatars.com/api/?name=NR+CREW&background=303030&color=fff&size=200",
    role: "Full-Stack Developer",
    company: "NR CREW",
    date: "Jun 2023 – Sep 2024",
    desc: "Engineered and successfully deployed robust web solutions including a comprehensive society management software and the TrackHub application, featuring secure payment integration and real-time transaction tracking.\n\n• Delivered scalable, high-performance web solutions across diverse client projects, ensuring code quality and rapid feature rollout.\n• Designed seamless frontend architectures and secure backend API communication.",
    skills: [
      "React.js",
      "JavaScript",
      "TypeScript",
      "Node.js",
      "Next.js",
      "MongoDB"
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://yt3.googleusercontent.com/ytc/AIdro_n1ksluIgtWVC879FrN7WMv_50OmRUawmiTspZ02pbmNm6e=s900-c-k-c0x00ffffff-no-rj",
    school: "Silver Oak University,Ahmedabad ",
    date: "Oct 2021 - May 2024",
    grade: "8.71 CGPA",
    desc: "I am complete Bca at Silver Oak University, Ahmedabad. I have completed 6 semesters and have last sem CGPA is 8.71. I have taken courses in  Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Computer Application - Bca",
  },
  {
    id: 1,
    img: "",
    school: "Ashish Hindi School",
    date: "Apr 2021",
    grade: "65%",
    desc: "I completed my class 12 high school education at Ashish Hindi School,Ahmedabad, where I studied Commerce",
    degree: "GSEB(XII)",
  },
  {
    id: 2,
    img: "",
    school: "Pushpanjali Vidhyalaya",
    date: "Apr 2019",
    grade: "63%",
    desc: "I completed my class 10 education at Pushpanjali Vidhyalaya,Ahmedabad.",
    degree: "GSEB(X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "Admin Dashboard",
    date: "june 2023 - may 2024",
    description:
      "Admin Dashboard is a dashboard for Admin. in this dashboard all the e-commerce site data and information are saved.and also graph are genrated.",
    image:
      "https://github.com/kunal0157/Admin-Dashboard-typescript/blob/main/src/assets/images/dash.png?raw=true",

    tags: ["React js", "TypeScript", "scss"],
    category: "web app",
    github: "https://github.com/kunal0157/Admin-Dashboard-typescript",
    webapp: "",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },
  {
    id: 2,
    title: "E-commerce Full Stack Website",
    date: "Jan 2024 - may 2024",
    description:
      "E-commerce is a website for clothes shop.it's my final year project.this project is full -stack website. it's make in nextjs.",
    image:
      "https://github.com/kunal0157/E-commerce-Full-Stack-Website/blob/main/src/assest/Screenshot%202024-03-26%20165959.png?raw=true",
    tags: [
      "React Js",
      "Tailwind Css",
      "Nextjs",
      "nodejs",
      "mongodb",
      "firebase",
    ],
    category: "web app",
    github: "https://github.com/kunal0157/E-commerce-Full-Stack-Website",
    webapp: "https://e-commerce-full-stack-website-nine.vercel.app/",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },
  {
    id: 0,
    title: "E-building",
    date: "June 2024 - may 2024",
    description:
      "Welcome to E-Building, your trusted partner in comprehensive building maintenance and gate security solutions. Our mission is to ensure that your properties remain in top-notch condition while providing unparalleled security to safeguard your premises. With a focus on excellence and customer satisfaction, we bring expertise, reliability, and innovative solutions to every project we undertake.",
    image: "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800",
    tags: [
      "React Js",
      "TypeScript",
      "antd",
      "jotai",
      "Tailwind css",
      "nodejs",
      "mongodb",
    ],
    category: "web app",
    //github: "https://github.com/kunal0157/currency-converter",
    webapp: "https://app-ebuilding-dev.vercel.app/",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },
  {
    id: 3,
    title: "TrackHub",
    date: "may 2024 - aug 2024",
    description:
      "TrackHub is web app. in this client can manage our daily basis store and add our regular user.and create bill and add product and user can subscribe his product.many features availavle for both store admin and customer.",
    image: "https://images.pexels.com/photos/590016/pexels-photo-590016.jpeg?auto=compress&cs=tinysrgb&w=800",
    tags: [
      "React Js",
      "TypeScript",
      "antd",
      "jotai",
      "Tailwind css",
      "nodejs",
      "mongodb",
    ],
    category: "web app",
    // github: "https://github.com/kunal0157/Password-manager",
    webapp: "https://trackhub-dev.vercel.app/login",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },

  {
    id: 4,
    title: "Yatharth Finance Cunsultonsy",
    date: "June 2024 - may 2024",
    description:
      "Yathath Finance Cunsultoncy is a company website. it's my first live project. in this website user can see all insurance services and fill form to but insurance.",
    image:
      "https://github.com/kunal0157/Yatharth-finance/blob/main/img/das.png?raw=true",
    tags: ["Html", "Css", "javaScript", "NodeMailer"],
    category: "web app",
    github: "https://github.com/kunal0157/Yatharth-finance",
    webapp: "https://yatharth-finance.vercel.app/",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },
  {
    id: 5,
    title: "Shree Mahalaxmi Engineering Company",
    date: "2026",
    description: "A professional business website developed for Shree Mahalaxmi Engineering Company. It showcases their manufacturing capabilities, industrial products, and overall operational excellence.",
    image: "https://images.pexels.com/photos/247763/pexels-photo-247763.jpeg?auto=compress&cs=tinysrgb&w=800",
    tags: ["React Js", "Tailwind CSS", "Next.js"],
    category: "web app",
    webapp: "https://shree-mahalaxmi-engineering.vercel.app/",
    member: [
      {
        name: "Dangi Kunal",
        img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
        linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
        github: "https://github.com/kunal0157",
      },
    ],
  },
  // {
  //   id: 6,
  //   title: "Tapan Logistics",
  //   date: "2026",
  //   description: "A modern import and export business website designed for Tapan Logistics, providing streamlined information about their global supply chain, transportation, and freight services.",
  //   image: "https://images.pexels.com/photos/1095814/pexels-photo-1095814.jpeg?auto=compress&cs=tinysrgb&w=800",
  //   tags: ["React Js", "Tailwind CSS", "Next.js"],
  //   category: "web app",
  //   webapp: "https://www.tapanlogistic.in/",
  //   member: [
  //     {
  //       name: "Dangi Kunal",
  //       img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
  //       linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
  //       github: "https://github.com/kunal0157",
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   title: "Dhrivon Engineering",
  //   date: "2026",
  //   description: "A comprehensive engineering company platform developed for Dhrivon, highlighting their specialized engineering services, portfolios, and deep technical expertise.",
  //   image: "https://images.pexels.com/photos/585419/pexels-photo-585419.jpeg?auto=compress&cs=tinysrgb&w=800",
  //   tags: ["React Js", "Tailwind CSS", "Next.js"],
  //   category: "web app",
  //   webapp: "https://www.dhrivon.com/",
  //   member: [
  //     {
  //       name: "Dangi Kunal",
  //       img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
  //       linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
  //       github: "https://github.com/kunal0157",
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   title: "React-Router-Web",
  //   date: "June 2024 - may 2024",
  //   description: "this is normal website for practice React-Router-web.",
  //   image:
  //     "https://github.com/kunal0157/react-router-web/blob/main/src/assets/Screenshot%202024-05-17%20110524.png?raw=true",
  //   tags: ["Html", "Css", "javaScript", "NodeMailer"],
  //   category: "web app",
  //   github: "https://github.com/kunal0157/react-router-web",
  //   webapp: "https://react-router-web-sepia.vercel.app/",
  //   member: [
  //     {
  //       name: "Dangi Kunal",
  //       img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
  //       linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
  //       github: "https://github.com/kunal0157",
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   title: "Theme-Switcher",
  //   date: "June 2024 - may 2024",
  //   description:
  //     "Theme Switcher is normal card componant in this project you can change theme light to dark.",
  //   image:
  //     "https://github.com/kunal0157/Theme-switcher/blob/main/src/assets/Screenshot%202024-05-17%20110406.png?raw=true",
  //   tags: ["Html", "Css", "javaScript", "NodeMailer"],
  //   category: "web app",
  //   github: "https://github.com/kunal0157/Theme-switcher",
  //   webapp: "https://theme-switcher-kappa-rust.vercel.app/",
  //   member: [
  //     {
  //       name: "Dangi Kunal",
  //       img: "https://avatars.githubusercontent.com/u/105959379?s=400&u=831423053e1b1bea46709f93aaf747551e4c86d5&v=4",
  //       linkedin: "https://www.linkedin.com/in/dangi-kunal-60a811227/",
  //       github: "https://github.com/kunal0157",
  //     },
  //   ],
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
